import 'styles/lp';
import 'javascripts/lp';
require.context('../', true, /\.(png|jpg|jpeg|svg)$/);
